import { Checkbox, Col, Layout, Menu, Row } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import menuItems, { IMenuItem } from 'src/Components/Menus/menuItems';

import LanguageSelector from './LanguageSelector';
import './MyHeader.css';

const {Header} = Layout;

const headerBackgroundColor = "white";

// const menuStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     flex: 1, // Take up all available space on the left
//     // backgroundColor: headerBackgroundColor,
//     // fontSize: "1.3em",
//     // lineHeight: "calc(1.3em + 8px)",
//     // boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.03)",
// };

// const headerStyle = {
//     backgroundColor: headerBackgroundColor,
//     height: "100%",
//     margin: "16px",
//     padding: "0",
//     display: "flex",
//     justifyContent: "space-between", // Align items with space between them
//     alignItems: "center", // Align items vertically at the center
// };

interface ThisComponentProps {
    onLanguageChange: (value: any) => void;
    setActivePage: (val: any) => void;
    isConnected?: boolean;
    isAdmin?: boolean;
}


const MyHeader: React.FC<ThisComponentProps> = ({onLanguageChange, setActivePage}) => {

    const [ isAdmin, setAdmin ] = useState(false);
    const onChangeAdmin = (e: CheckboxChangeEvent) => {
        setAdmin(e.target.checked);
    };

    const [ isConnected, setConnected ] = useState(true);
    const onChange = (e: CheckboxChangeEvent) => {
        setConnected(!e.target.checked);
    };

    const visibleMenuItems = menuItems.filter(
            (item) => {
                return (!item.must_be_admin ?? true) || (isAdmin ?? false);
            }
        ).map(e => (
            {
                ...e, disabled: e.must_be_connected && (isConnected ?? false)
            }
        ))
    ;

    const findOption = (key: any, menus: IMenuItem[] | undefined): any => {
        // console.log('findOptions', key)
        // console.log(menus)
        const newKey = key.pop();
        // console.log(newKey)
        if (newKey === 'rc-menu-more') {
            return findOption(key, menus);
        }
        if (key.length > 0) {
            const newMenu = findMenu(newKey, menus).children;
            return findOption(key, newMenu);
        } else {
            return findMenu(newKey, menus);
        }
    }

    const findMenu = (key: any, menus: IMenuItem[] | undefined) => {
        console.log('findMenu', key, menus)
        const menu = menus?.find((m: IMenuItem) => m.key === key) ?? menuItems[0];
        console.log('findMenu', menu)
        return menu;
    }

    // const onClick = (e: any) => {
    //     console.log('Onclick start')
    //     console.log(e.keyPath)
    //     console.log(menuItems)
    //     console.log('Onclick end')
    //     const option = findOption(e.keyPath, menuItems);
    //     setActivePage(option ? option : menuItems[0]);
    // };
    //
    const setLocale = (lang: any): void => {
        onLanguageChange(lang);
    }

    const navigate = useNavigate();

    return (
        <>
            <Row>
                <Col flex={5}>
                    <Checkbox onChange={onChange}>Connect</Checkbox>
                    <Checkbox onChange={onChangeAdmin} disabled={isConnected}>Admin Mode</Checkbox>
                </Col>
                <Col flex={3}>
                    <div className={"LanguageSelector"}>
                        <LanguageSelector onLanguageChange={setLocale}/>
                    </div>
                </Col>
            </Row>
            <Header className={"myHeader"}>
                <Menu mode="horizontal"
                      defaultSelectedKeys={[ window.location.pathname ]}
                      items={visibleMenuItems}
                      onClick={({key}) => {
                          navigate(key);
                      }}
                      className={"menuStyle"}
                />
            </Header>
        </>
    );

}
export default MyHeader;
